module.exports = __webpack_public_path__ + "static/media/n_icon_tab@2x.a4c14aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_tab@2x.png
// module id = 1816
// module chunks = 0 1